import { useEffect, useState } from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";
import axios from "../../axios";
import LoadingPage from "../../components/pages/Loading";
import NoDataPage from "../../components/pages/NoData";
import { tokenState, userState } from "../../storage/auth";
import { titleState } from "../../storage/pages";
import { LayoutTable, LayoutThead } from "../../components/layouts/Table";
import {
  defaultFilterBulan,
  defaultFilterTahun,
  FilterBulan,
  FilterCabang,
  FilterTahun,
} from "../../components/layouts/TopContent";
import { formatDate, formatTimeStamp } from "../../helpers";
import TableNew, { Tbody, Td, Th, Thead, Tr } from "../../components/layouts/TableNew";

const LemburHrd = () => {
  const setTitle = useSetRecoilState(titleState);
  const token = useRecoilValue(tokenState);
  const user = useRecoilValue(userState);
  const [isLoaded, setIsLoaded] = useState();

  const [items, setItems] = useState();
  const [page] = useState("all");
  const [bulan, setBulan] = useState(defaultFilterBulan);
  const [tahun, setTahun] = useState(defaultFilterTahun);
  const [cabang, setCabang] = useState("");

  useEffect(() => {
    setTitle("Semua Data Lembur");
    const fetchData = async () => {
      try {
        const res = await axios.get(
          "/api/lembur" +
            "?page=" +
            page +
            "&bulan=" +
            bulan +
            "&tahun=" +
            tahun +
            "&cabang=" +
            cabang,
          { headers: { Authorization: "Bearer " + token } }
        );
        if (res.data) {
          setItems(res.data.lembur);
          setIsLoaded(true);
        }
      } catch (err) {
        console.log(err);
      }
    };

    fetchData();
  }, [setTitle, page, bulan, tahun, cabang, token]);

  if (isLoaded && user.cabang === "pusat") {
    return (
      <>
        <div className="row mb-2">
          <div className="col-md">
            <FilterCabang pusat={true} onChange={(res) => setCabang(res)} />
          </div>
          <div className="col-md">
            <FilterBulan onChange={(res) => setBulan(res)} />
          </div>
          <div className="col-md">
            <FilterTahun onChange={(res) => setTahun(res)} />
          </div>
        </div>

        {items && items.length > 0 ? (
          <TableNew>
            <Thead>
              <Tr className="text-center text-nowrap">
                <Th rowSpan={2} className='align-middle'>No</Th>
                <Th rowSpan={2} className='align-middle'>Cabang</Th>
                <Th rowSpan={2} className='align-middle'>NIP</Th>
                <Th rowSpan={2} className='align-middle'>Nama</Th>
                <Th rowSpan={2} className='align-middle'>Jenis</Th>
                <Th rowSpan={2} className='align-middle'>Dari</Th>
                <Th rowSpan={2} className='align-middle'>Sampai</Th>
                <Th colSpan={3} className='align-middle'>Lama</Th>
                <Th rowSpan={2} className='align-middle'>Pekerjaan</Th>
                <Th rowSpan={2} className='align-middle'>Keterangan</Th>
                <Th rowSpan={2} className='align-middle'>Type Lembur</Th>
                <Th rowSpan={2} className='align-middle'>Status</Th>
                <Th rowSpan={2} className='align-middle'>Approval</Th>
                <Th rowSpan={2} className='align-middle'>Created At</Th>
                <Th rowSpan={2} className='align-middle'>Update At</Th>
              </Tr>
              <Tr className="text-center">
                <Th>Hari</Th>
                <Th>Jam</Th>
                <Th>Menit</Th>
              </Tr>
            </Thead>
            <Tbody>
              {items.map((i, index) => {
                return (
                  <Tr key={index}>
                    <Td className="text-center align-middle">{1 + index}</Td>
                    <Td className="text-nowrap text-center align-middle">
                      {i.pegawai && i.pegawai.cabang}
                    </Td>
                    <Td className="text-nowrap text-center align-middle">
                      {i.pegawai && i.pegawai.nip}
                    </Td>
                    <Td className="text-nowrap text-center align-middle">
                      {i.pegawai && i.pegawai.nama}
                    </Td>
                    <Td className="text-nowrap text-center align-middle">
                      {parseInt(i.status_keterangan) === 1 && (
                        <span className="text-info">Hari Normal</span>
                      )}
                      {parseInt(i.status_keterangan) === 2 && (
                        <span className="text-primary">Hari Libur</span>
                      )}
                      {parseInt(i.status_keterangan) === 3 && (
                        <span className="text-success">Pagi Hari</span>
                      )}
                    </Td>
                    <Td className="text-nowrap text-center align-middle">
                      {formatDate(i.dari, false)}
                    </Td>
                    <Td className="text-nowrap text-center align-middle">
                      {formatDate(i.sampai, false)}
                    </Td>
                    <Td className="text-nowrap text-center align-middle">
                      {i.lama && i.lama.split(" | ")[0].split(" ")[0]}
                    </Td>
                    <Td className="text-nowrap text-center align-middle">
                      {i.lama && i.lama.split(" | ")[1].split(" ")[0]}
                    </Td>
                    <Td className="text-nowrap text-center align-middle">
                      {i.lama && i.lama.split(" | ")[2].split(" ")[0]}
                    </Td>
                    <Td className="align-middle">{i.pekerjaan}</Td>
                    <Td className="align-middle">{i.keterangan}</Td>
                    <Td className="text-center align-middle">
                      {parseInt(i.type_lembur) === 1 && "Lembur Jabatan"}
                      {parseInt(i.type_lembur) === 2 &&
                        "Lembur Kegiatan Mahasiswa"}
                      {parseInt(i.type_lembur) === 3 && "Lembur Kepanitiaan"}
                      {parseInt(i.type_lembur) === 4 &&
                        "Lembur Menghadiri Rapat atau Undangan Kegiatan"}
                    </Td>
                    <Td className="text-center align-middle">
                      {parseInt(i.status) === 1 && (
                        <span className="text-success">Approved</span>
                      )}
                      {parseInt(i.status) === 2 && (
                        <span className="text-danger">Rejected</span>
                      )}
                      {!parseInt(i.status) && (
                        <span className="text-warning">Waiting</span>
                      )}
                    </Td>
                    <Td className="text-nowrap text-center align-middle">
                      {i.atasan && i.atasan.nama}
                    </Td>
                    <Td className="text-nowrap text-center align-middle">
                      {formatTimeStamp(i.created_at)}
                    </Td>
                    <Td className="text-nowrap text-center align-middle">
                      {formatTimeStamp(i.updated_at)}
                    </Td>
                  </Tr>
                );
              })}
            </Tbody>
          </TableNew>
        ) : (
          <NoDataPage />
        )}
      </>
    );
  } else {
    return <LoadingPage />;
  }
};

export default LemburHrd;
